import { GET_INTERNAL_DASHBOARD_COUNT_ERR, GET_INTERNAL_DASHBOARD_COUNT } from '../../actionTypes/internalDashboardType'
import { getInternalDashboardCountApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getInternalDashboardCount = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getInternalDashboardCountApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_INTERNAL_DASHBOARD_COUNT,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_INTERNAL_DASHBOARD_COUNT_ERR,
            payload: error && error.response
        });
    }
}


